export class ProfileStatusModel {
  status: string;
  display: string;
  class: string;
  classForegroundOnly: string;
  classBackgroundOnly: string;
  icon: string;
}
